import api from './api';

export default {
  blockUser: (userId) => api.post('blockUser', { user_id: userId }),
  unblockUser: (userId) => api.post('unBlockUser', { user_id: userId }),
  isUserBlocked: (userId) => api.get(`isUserBlocked/${userId}`),
};
